<template>
  <div>
    <VUserManagerTable />
  </div>
</template>
<script>
import { createUserManagerMixin } from '@/mixins/userManagerMixin'

export default {
  name: 'UserManager',

  mixins: [
    createUserManagerMixin(['mutations', 'getters'])
  ]
}
</script>
